import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import {
	Button,
	Col,
	Form,
	FormFeedback,
	FormGroup,
	Input,
	Label,
	Row,
} from "reactstrap";
import { useFormik } from "formik";
import withRouter from "../../../../../components/Common/withRouter";
import { useNavigate } from "react-router-dom";
import userService from "services/UserService";
import ReactInputMask from "react-input-mask";
import Swal from "sweetalert2";
import { registerLocale } from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import userRoleService from "services/UserRoleService";
import organizationalStructureService from "services/OrganizationalStructureService";
import companyService from "services/CompanyService";
import authPermissionService from "services/AuthPermissionService";
import Loading from "components/Common/Loading";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";
registerLocale("pt-BR", pt);

const FormMeuPerfil = (props) => {
	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [funcoes, setFuncoes] = useState([]);
	const [organizacoes, setOrganizacoes] = useState([]);
	const [empresaAtual, setEmpresaAtual] = useState(null);
	const [permissions, setPermissions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [id, setId] = useState(null);

	const navigate = useNavigate();

	const genders = [
		{ value: "1", label: "Masculino" },
		{ value: "2", label: "Feminino" },
	];

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			id: data?.id || null,
			name: data?.name || null,
			lastname: data?.lastname || null,
			email: data?.email || null,
			phone: data?.phone || null,
			birthdate: data?.birthdate || null,
			admission_date: data?.admission_date || null,
			gender: data?.gender || null,
			organization_id: data?.organization_id || null,
			scholarity: data?.scholarity || null,
			legal_contact: data?.legal_contact || null,
			company_contact: data?.company_contact || null,
			is_organization_leader: data?.is_organization_leader || null,
			password: "",
			confirm_password: "",
		},

		validate: (values) => {
			const errors = {};

			if (!values.name) {
				errors.name = "Campo obrigatório";
			}
			if (!values.lastname) {
				errors.lastname = "Campo obrigatório";
			}
			if (!values.email) {
				errors.email = "Campo obrigatório";
			}
			if (!values.phone) {
				errors.phone = "Campo obrigatório";
			}
			if (!values.password && !values.id) {
				errors.password = "Campo obrigatório";
			}
			if (!values.confirm_password && !values.id) {
				errors.confirm_password = "Campo obrigatório";
			}
			if (values.password !== values.confirm_password) {
				errors.confirm_password = "As senhas não coincidem";
			}
			if (!values.permission_id && !values.id) {
				errors.permission_id = "Campo obrigatório";
			}

			return errors;
		},

		onSubmit: async (values, { setSubmitting }) => {
			const errors = await validation.validateForm(values);
			if (Object.keys(errors).length === 0) {
				setLoading(true);
				try {
					if (id) {
						await userService.putProfile(id, values);
					}

					SendaCustomSwal.fire({
						iconHtml: '<i class="success-icon"></i>',
						title: "Sucesso",
						text: "Formulário enviado com sucesso!",
						customClass: {
							confirmButton: "custom-confirm-button",
						},
					}).then((result) => {
						if (result.isConfirmed) {
							window.location.reload();
						}
					});
				} catch (error) {
					SendaCustomSwal.fire({
						iconHtml: '<i class="error-icon"></i>',
						title: "Oops...",
						text: "Algo deu errado!",
						customClass: {
							confirmButton: "custom-confirm-button",
						},
					});
				} finally {
					setLoading(false);
				}
			}
			setSubmitting(false);
		},
	});

	const getItems = async () => {
		try {
			const response = await userService.getById(id);

			setData(response);
		} catch (error) {
			console.log(error);
		}
	};

	async function getPermissions() {
		try {
			const response = await authPermissionService.get();
			const permissions = response.map((item) => {
				return {
					value: item.id,
					label: item.name,
				};
			});
			setPermissions(permissions);
		} catch (error) {
			console.log(error);
		}
	}

	async function getFuncoes() {
		try {
			const response = await userRoleService.get();
			const funcoes = response.map((item) => {
				return {
					value: item.id,
					label: item.name,
				};
			});
			setFuncoes(funcoes);
			setIsLoading(false);
		} catch (error) {
			console.log(error);
		}
	}

	const buscaUsuario = async () => {
		const user = JSON.parse(localStorage.getItem("authUser"));
		setId(user?.user?.id);
	};

	async function getOrganizacoes() {
		try {
			const response = await organizationalStructureService.get();

			const organizacoes = response.map((item) => {
				return {
					value: item.id,
					label: item.name,
				};
			});
			setOrganizacoes(organizacoes);
			setIsLoading(false);
		} catch (error) {
			console.log(error);
		}
	}

	const getAll = async () => {
		await getItems();
		await getPermissions();
		await getFuncoes();
		await getOrganizacoes();
	};

	useEffect(() => {
		if (id) {
			getAll();
		}
	}, [id]);

	useEffect(() => {
		buscaUsuario();
	}, []);

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			color: state.isSelected ? "blue" : "black",
			backgroundColor: "white",
			"&:hover": {
				backgroundColor: "#556ee6",
			},
		}),
	};

	return (
		<Loading isLoading={isLoading}>
			<div className="page-content">
				<div
					className="container-fluid"
					style={{
						backgroundColor: "white",
						paddingLeft: 20,
						paddingTop: 20,
						paddingBottom: 10,
						paddingRight: 20,
						borderRadius: 10,
					}}
				>
					<h2
						style={{
							fontWeight: 800,
						}}
					>
						Meu perfil
					</h2>
				</div>
				<div
					className="container-fluid"
					style={{
						backgroundColor: "white",
						padding: 20,
						borderRadius: 10,
						marginTop: 25,
					}}
				>
					<Form
						className="needs-validation"
						onSubmit={(e) => {
							e.preventDefault();
							validation.handleSubmit();
							return false;
						}}
					>
						<Row>
							<Col md="6">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Nome Completo
									</Label>
									<Input
										name="name"
										placeholder="Nome Completo"
										type="text"
										className="form-control"
										id="validationCustom01"
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.name || ""}
										invalid={
											validation.touched.name &&
											validation.errors.name
												? true
												: false
										}
									/>
									{validation.touched.name &&
									validation.errors.name ? (
										<FormFeedback type="invalid">
											{validation.errors.name}
										</FormFeedback>
									) : null}
								</FormGroup>
							</Col>

							<Col md="6">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Apelido
									</Label>
									<Input
										name="lastname"
										placeholder="Apelido"
										type="text"
										className="form-control"
										id="validationCustom01"
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.lastname || ""}
										invalid={
											validation.touched.lastname &&
											validation.errors.lastname
												? true
												: false
										}
									/>
									{validation.touched.lastname &&
									validation.errors.lastname ? (
										<FormFeedback type="invalid">
											{validation.errors.lastname}
										</FormFeedback>
									) : null}
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col md="6">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Email
									</Label>
									<Input
										name="email"
										placeholder="Email"
										type="text"
										className="form-control"
										id="validationCustom01"
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										required={true}
										value={validation.values.email || ""}
										invalid={
											validation.touched.email &&
											validation.errors.email
												? true
												: false
										}
									/>
									{validation.touched.email &&
									validation.errors.email ? (
										<FormFeedback type="invalid">
											{validation.errors.email}
										</FormFeedback>
									) : null}
								</FormGroup>
							</Col>

							<Col md="6">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Telefone
									</Label>
									<ReactInputMask
										name="phone"
										placeholder="Telefone"
										type="text"
										className="form-control"
										mask="(99) 99999-9999"
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.phone || ""}
										invalid={
											validation.touched.phone &&
											validation.errors.phone
												? true
												: false
										}
									/>
									{validation.touched.phone &&
									validation.errors.phone ? (
										<FormFeedback type="invalid">
											{validation.errors.phone}
										</FormFeedback>
									) : null}
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col md="6">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Data de nascimento
									</Label>
									<Input
										name="birthdate"
										type="date"
										className="form-control"
										placeholderText="Data de nascimento"
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={
											validation.values.birthdate || ""
										}
										invalid={
											validation.touched.birthdate &&
											validation.errors.birthdate
										}
									/>
								</FormGroup>
							</Col>

							<Col md="6">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Gênero
									</Label>
									<Select
										styles={customStyles}
										placeholder="Selecione o Gênero"
										onChange={(selectedOption) => {
											const selectedValue = selectedOption
												? selectedOption.value
												: "";
											validation.setFieldValue(
												"gender",
												selectedValue,
											);
										}}
										value={genders.find(
											(option) =>
												option.value ===
												validation.values.gender,
										)}
										options={genders}
									/>
								</FormGroup>
							</Col>
						</Row>

						{/* <Row>
							<Col md="4">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Organização
									</Label>
									<Select
										styles={customStyles}
										placeholder="Selecione a organização"
										onChange={(selectedOption) => {
											const selectedValue = selectedOption
												? selectedOption.value
												: null;
											validation.setFieldValue(
												"organization_id",
												selectedValue,
											);
										}}
										value={organizacoes?.find(
											(option) =>
												option.value ===
												validation.values
													.organization_id,
										)}
										options={organizacoes}
									/>
								</FormGroup>
							</Col>

							<Col md="4">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Função
									</Label>
									<Select
										styles={customStyles}
										placeholder="Selecione a função"
										onChange={(selectedOption) => {
											const selectedValue = selectedOption
												? selectedOption.value
												: "";
											validation.setFieldValue(
												"role_id",
												selectedValue,
											);
										}}
										options={funcoes}
										value={funcoes?.find(
											(option) =>
												option.value ===
												validation.values.role_id,
										)}
									/>
								</FormGroup>
							</Col>
							<Col md="4">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Data de Admissão
									</Label>
									<Input
										name="admission_date"
										type="date"
										className="form-control"
										placeholderText="Data de admissão"
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={
											validation.values.admission_date ||
											""
										}
										invalid={
											validation.touched.admission_date &&
											validation.errors.admission_date
										}
									/>
								</FormGroup>
							</Col>
						</Row> */}
						<Row>
							<Col md="6">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Senha
									</Label>
									<Input
										name="password"
										placeholder="Senha"
										type="password"
										className="form-control"
										id="validationCustom01"
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={validation.values.password || ""}
										invalid={
											validation.touched.password &&
											validation.errors.password
												? true
												: false
										}
									/>
									{validation.touched.password &&
									validation.errors.password ? (
										<FormFeedback type="invalid">
											{validation.errors.password}
										</FormFeedback>
									) : null}
								</FormGroup>
							</Col>
							<Col md="6">
								<FormGroup className="mb-3">
									<Label htmlFor="validationCustom01">
										Confirmação de senha
									</Label>
									<Input
										name="confirm_password"
										placeholder="Confirmação de senha"
										type="password"
										className="form-control"
										id="validationCustom01"
										onChange={validation.handleChange}
										onBlur={validation.handleBlur}
										value={
											validation.values
												.confirm_password || ""
										}
										invalid={
											validation.touched
												.confirm_password &&
											validation.errors.confirm_password
												? true
												: false
										}
									/>
									{validation.touched.confirm_password &&
									validation.errors.confirm_password ? (
										<FormFeedback type="invalid">
											{validation.errors.confirm_password}
										</FormFeedback>
									) : null}
								</FormGroup>
							</Col>
						</Row>
						{/* <Row>
							<Col md="4">
								<FormGroup className="mb-3">
									<label
										className="form-check-label"
										htmlFor="is_organization_leader"
									>
										<Input
											type="checkbox"
											className="form-check-input"
											id="is_organization_leader"
											name="is_organization_leader"
											defaultChecked={
												validation.values
													.is_organization_leader
											}
											onChange={(event) => {
												const value = event.target
													.checked
													? 1
													: null;
												validation.setFieldValue(
													"is_organization_leader",
													value,
												);
											}}
											style={{ marginRight: 10 }}
										/>
										Líder
									</label>
								</FormGroup>
							</Col>
							<Col md="4">
								<FormGroup className="mb-3">
									<input
										type="checkbox"
										className="form-check-input"
										id="company_contact"
										name="company_contact"
										defaultChecked={
											validation.values.company_contact
										}
										onChange={(event) => {
											const value = event.target.checked
												? 1
												: null;
											validation.setFieldValue(
												"company_contact",
												value,
											);
										}}
									/>
									<label
										className="form-check-label"
										htmlFor="company_contact"
										style={{ marginLeft: 10 }}
									>
										Contato da empresa
									</label>
								</FormGroup>
							</Col>
							<Col md="4">
								<FormGroup className="mb-3">
									<input
										type="checkbox"
										className="form-check-input"
										id="legal_contact"
										name="legal_contact"
										defaultChecked={
											validation.values.legal_contact
										}
										onChange={(event) => {
											const value = event.target.checked
												? 1
												: null;
											validation.setFieldValue(
												"legal_contact",
												1,
											);
										}}
									/>
									<label
										className="form-check-label"
										htmlFor="legal_contact"
										style={{ marginLeft: 10 }}
									>
										Contato Legal
									</label>
								</FormGroup>
							</Col>
						</Row> */}
						<div
							className="page-title-right"
							style={{ width: "100%", textAlign: "right" }}
						>
							<Button
								color="primary"
								type="submit"
								disabled={validation.isSubmitting}
							>
								{loading ? (
									<span
										className="spinner-border spinner-border-sm mr-1"
										style={{ marginRight: 10 }}
									></span>
								) : null}
								Salvar
							</Button>
						</div>
					</Form>
				</div>
			</div>
		</Loading>
	);
};
FormMeuPerfil.propTypes = {
	preGlobalFilteredRows: PropTypes.any,
};

export default withRouter(FormMeuPerfil);
